import React from 'react'
import Login from '../components/Login'
import SignUp from '../components/SignUp'
import Footer from '../components/Footer'

export const Auth = (props) => {
    const { page } = props;
  return (
    <div>
        {page === 'login' ? (
            <Login />
        ) : page === 'register' ? (
            <SignUp />
        ) : null}
        {/* Footer */}
        <Footer variant="full" />
    </div>
  )
}
